import React, { useEffect, useState } from "react";
import {
  Box,
  Grid,
  Typography,
  Button,
  IconButton,
  Drawer,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import {
  CmpStatusIcon,
  CmpTypographyField,
} from "../../../Component/Common/ToolBox/ToolBox";
import moment from "moment";
import dayjs from "dayjs";
import SideNavToolbar from "../Components/SidenavToolbar";
import { PAP_Head_PostApi } from "../../../Server/ApiV2";
import { useLocation } from "react-router-dom";
import { fAlertToast } from "../../../Utility/Utilitys";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const SendPrintingSideNav = ({
  open,
  onClose,
  selectedPromo,
  setSelectedPromo,
  userCd,
  fLoad,
}) => {
  const [data, setData] = useState({});
  const queryParams = useLocation();

  const pageType = queryParams.search.split("typ=")[1];
  useEffect(() => {
    if (open && selectedPromo) {
      setData({
        TransId: selectedPromo.TransId || "",
        TransDate: selectedPromo.TransDate
          ? dayjs(selectedPromo.TransDate)
          : dayjs(),
        Location: selectedPromo.Location || "",
        TransLocName:
          selectedPromo.TransLocName || selectedPromo.LocationName || "",
        PromoLoc: selectedPromo.PromoLoc || "",
        PromoLocName: selectedPromo.PromoLocName || "",
        PromoTitle: selectedPromo.PromoTitle || "",
        Status: selectedPromo.ProofRead_Status || "",
      });
    }
  }, [open, selectedPromo]);

  const fPost = async () => {
    const obj = {
      TransId: selectedPromo.TransId,
      UserCd: userCd ?? "",
      Typ: pageType === "Print" ? "P" : "PR",
    };
    const result = await PAP_Head_PostApi(obj);
    console.log("result,", result);

    if (result?.status === 200) {
      fAlertToast("SUCCESS", "Post Successfully");
      setData((prev) => ({ ...prev }));

      onClose();
      await fLoad();
    } else {
      fAlertToast("ERROR", "Post Failed");
    }
  };
  console.log("data,", data);

  return (
    <Drawer
      anchor="right"
      open={open}
      // onClose={onClose}
      sx={{
        "& .MuiDrawer-paper": {
          width: { xs: "100%", sm: 450, md: "500px !important" },
        },
      }}
    >
      <Box mt={4}>
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          mb={1}
          p={1}
          mt={1}
          sx={{
            background: "linear-gradient(135deg, #1e88e5 0%, #673ab7 100%)",
            color: "#fff",
          }}
        >
          <div style={{ display: "flex", flexDirection: "row" }}>
            <IconButton
              edge="end"
              onClick={() => {
                onClose();
                setSelectedPromo({});
              }}
              aria-label="close"
              sx={{
                fontSize: "20px !important",
                color: "#ffffff",
                backgroundColor: "rgba(255,255,255,0.15)",
                "&:hover": {
                  backgroundColor: "rgba(255,255,255,0.25)",
                },
              }}
            >
              <ArrowBackIcon />
            </IconButton>
            <Typography
              variant="h6"
              sx={{ fontWeight: 500, marginLeft: "22px", marginTop: "4px" }}
            >
              Printing Details
            </Typography>
          </div>

          <IconButton
            onClick={() => {
              onClose();
              setSelectedPromo({});
            }}
            sx={{
              color: "#ffffff",
              backgroundColor: "rgba(255,255,255,0.15)",
              "&:hover": {
                backgroundColor: "rgba(255,255,255,0.25)",
              },
            }}
          >
            <CloseIcon />
          </IconButton>
        </Box>
        <SideNavToolbar
          transId={selectedPromo?.TransId || ""}
          userCd={userCd}
          selectedRow={selectedPromo}
          loadSummary={fLoad}
        />
      </Box>
      <Box sx={{ p: 3, backgroundColor: "#fff" }}>
        <Box
          sx={{
            border: "1px solid #e0e0e0",
            borderRadius: 2,
            p: 2,
            backgroundColor: "#fff",
          }}
        >
          <Grid
            container
            spacing={4}
            sx={{
              "& .MuiOutlinedInput-input": {
                padding: "12px 14px !important",
              },
            }}
          >
            <Grid item xs={12}>
              <Grid container>
                <Grid item xs={3.2} sm={2.5} md={2.5}>
                  <CmpTypographyField xText={"TransID "} xMarginTop="7px" />
                </Grid>
                <Grid item xs={0.4} sm={0.5} md={0.5}>
                  <CmpTypographyField xText={":"} xMarginTop="7px" />
                </Grid>
                <Grid item xs={8.4} sm={9} md={9} mb="2px">
                  <Typography
                    variant="subtitle2"
                    marginTop={"8px"}
                    fontWeight={600}
                  >
                    {selectedPromo.TransId}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12}>
              <Grid container>
                <Grid item xs={3.2} sm={2.5} md={2.5}>
                  <CmpTypographyField xText={"Trans date"} xMarginTop="7px" />
                </Grid>
                <Grid item xs={0.4} sm={0.5} md={0.5}>
                  <CmpTypographyField xText={":"} xMarginTop="7px" />
                </Grid>
                <Grid item xs={8.4} sm={9} md={9}>
                  <Typography
                    variant="subtitle2"
                    marginTop={"10px"}
                    fontWeight={600}
                  >
                    {moment(selectedPromo?.TransDate).format("DD/MM/YYYY")}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <Grid container>
                <Grid item xs={3.2} sm={2.5} md={2.5}>
                  <CmpTypographyField xText={"Location "} xMarginTop="7px" />
                </Grid>
                <Grid item xs={0.4} sm={0.5} md={0.5}>
                  <CmpTypographyField xText={":"} xMarginTop="7px" />
                </Grid>
                <Grid item xs={8.4} sm={9} md={9}>
                  <Typography
                    variant="subtitle2"
                    marginTop={"8px"}
                    fontWeight={600}
                  >
                    {selectedPromo.TransLocName}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12}>
              <Grid container>
                <Grid item xs={3.2} sm={2.5} md={2.5}>
                  <CmpTypographyField xText={"PromoLoc"} xMarginTop="7px" />
                </Grid>
                <Grid item xs={0.4} sm={0.5} md={0.5}>
                  <CmpTypographyField xText={":"} xMarginTop="7px" />
                </Grid>
                <Grid item xs={8.4} sm={9} md={9}>
                  <Typography
                    variant="subtitle2"
                    marginTop={"8px"}
                    fontWeight={600}
                  >
                    {selectedPromo.PromoLocName}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12}>
              <Grid container>
                <Grid item xs={3.2} sm={2.5} md={2.5}>
                  <CmpTypographyField xText={"Status "} xMarginTop="7px" />
                </Grid>
                <Grid item xs={0.4} sm={0.5} md={0.5}>
                  <CmpTypographyField xText={":"} xMarginTop="7px" />
                </Grid>
                <Grid item xs={8.4} sm={9} md={9} marginTop={"6px"}>
                  <CmpStatusIcon xStatus={selectedPromo?.Print_Status} />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              gap: 2,
              mt: 6,
            }}
          >
            <Button
              variant="contained"
              color="success"
              onClick={fPost}
              disabled={selectedPromo?.Print_Status === "POST"}
              sx={{ width: 120 }}
            >
              Post
            </Button>
          </Box>
        </Box>
      </Box>
    </Drawer>
  );
};

export default SendPrintingSideNav;
